import React from "react";
import { Link } from "react-router-dom"; // or use Next.js Link if you're using Next.js
import CustomPrimaryButton from "./CustomPrimaryButton";

// Component definition
const TitleWithIconLink = ({ title, linkText, icon, linkUrl, isDirty }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 0",
      }}
    >
      {/* Title section (left side) */}
      <div
        style={{
          fontSize: "16px",
          fontFamily: "Poppins-Medium",
          color: "#000000",
        }}
      >
        {title}
      </div>

      {/* Link section (right side) */}
      {isDirty && (
        <CustomPrimaryButton title={linkText} onClick={linkUrl} icon={icon} />
      )}
      {/* <Link
        to={linkUrl}
        style={{
          display: "flex",
          alignItems: "center",
          color: "#007bff", // You can change this to any color you prefer
          textDecoration: "none", // Removes underline
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontSize: "16px",
            fontFamily: "Poppins-Medium",
            color: "#20C3FF",
          }}
        >
          <span>{linkText}</span>

          <img
            src={icon}
            style={{ marginRight: "8px", fontSize: "16px" }} // Adjust icon size if needed
          />
        </div>
      </Link> */}
    </div>
  );
};

export default TitleWithIconLink;
